import { Helmet } from 'react-helmet-async';

// DOMAIN CONFIGURATION: Update the default domain below if you change your domain
// Replace "https://www.leachouri-mohamed.online/" with your new domain
const DEFAULT_DOMAIN = "https://www.leachouri-mohamed.online/";

const SEO = ({ 
  title = "Mohamed LEACHOURI | Java Fullstack Developer & Software Engineer Portfolio",
  description = "Portfolio of Mohamed LEACHOURI - Java Fullstack Developer & Software Engineer with 4+ years of experience. Specializing in Java, Spring Boot, React, Angular, and DevOps.",
  keywords = "Java Developer, Fullstack Developer, Software Engineer, Spring Boot, React, Angular, JavaScript, TypeScript, Microservices, DevOps, Portfolio",
  image = `${DEFAULT_DOMAIN}logo512.png`,
  url = DEFAULT_DOMAIN,
  type = "website"
}) => {
  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{title}</title>
      <meta name="title" content={title} />
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      
      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={url} />
      <meta property="twitter:title" content={title} />
      <meta property="twitter:description" content={description} />
      <meta property="twitter:image" content={image} />
      
      {/* Canonical URL */}
      <link rel="canonical" href={url} />
    </Helmet>
  );
};

export default SEO;

